import React, { useEffect } from "react";
import "./App.css";

import {
  Route,
  Routes,
  BrowserRouter,
  useLocation,
} from "react-router-dom";

import Home from "./Pages/Home";
import Park from "./Pages/Park";
import Downtown from "./Pages/Downtown";
import Contact from "./Pages/Contact";
import About from "./Pages/About";
import Gallery from "./Pages/Gallery";
import BookApartment from "./Pages/BookApartment";
import Whatsapp from "./Pages/Whatsapp";
import Square from "./Pages/Square";

import AOS from "aos";
import "aos/dist/aos.css";

import ReactGA from "react-ga4";

// Initialize Google Analytics ONLY ONCE
ReactGA.initialize("G-J9T45RTKYS");

function App() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 800,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
      disableMutationObserver: false,
    });
  }, []);

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when changing pages
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    // Google Analytics page view
    ReactGA.send({
      hitType: "pageview",
      page: pathname,
    });

    // Wait for the new page's DOM to actually paint before refreshing AOS,
    // instead of refreshing instantly (which causes the header to reset/blink)
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/square" element={<Square />} />
        <Route path="/park" element={<Park />} />
        <Route path="/swissresidencies" element={<Downtown />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/bookapartment" element={<BookApartment />} />
      </Routes>
      <Whatsapp />
    </div>
  );
}

export default App;